"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _carousel = _interopRequireDefault(require("./carousel"));

var _horizontalScroll = _interopRequireDefault(require("./horizontal-scroll"));

var _navCarousel = _interopRequireDefault(require("./nav-carousel"));

var _madLibEmail = _interopRequireDefault(require("./mad-lib-email"));

require("./list.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Renders a header, subtitle, and list (children).
 * @param children - React children, should be a an array.
 * @param className - Class applied to wrapper element.
 * @param subTitle - Text used for Subtitle.
 * @param title - Text used for title.
 * @param displayOption - Decides how to display list, see proptypes
 */
var List = function List(_ref) {
  var children = _ref.children,
      className = _ref.className,
      displayOption = _ref.displayOption,
      subTitle = _ref.subTitle,
      title = _ref.title;
  var listView;

  switch (displayOption) {
    case 'Carousel':
      {
        listView = /*#__PURE__*/_react["default"].createElement(_carousel["default"], null, children);
        break;
      }

    case 'Horizontal Scroll':
      {
        listView = /*#__PURE__*/_react["default"].createElement(_horizontalScroll["default"], null, children);
        break;
      }

    case 'NavCarousel':
      {
        listView = /*#__PURE__*/_react["default"].createElement(_navCarousel["default"], null, children);
        break;
      }
    // Special List, renders itself

    case 'Mad Lib Flow':
      {
        return /*#__PURE__*/_react["default"].createElement(_madLibEmail["default"], {
          className: className
        }, children);
      }

    default:
      {
        // Ported from previous list implementation
        // All the rest are legacy default styles that rely on the following dom structure.
        // Eventually should break these in to own components
        listView = /*#__PURE__*/_react["default"].createElement("div", {
          className: "Sections"
        }, children);
      }
  }

  var hasTitle = !!(title || subTitle);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('List', className, {
      hasTitle: hasTitle
    })
  }, title ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: "h2 title"
  }, title) : null, subTitle ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "subTitle"
  }, subTitle) : null, listView);
};

List.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].node),
  className: _propTypes["default"].string,
  displayOption: _propTypes["default"].oneOf(['Vertical List', 'Full Width', 'Grid', 'Grid Two Columns', 'Grid Three Columns', 'Grid Four Columns', 'Grid Five Columns', 'Grid Six Columns', 'Carousel', 'NavCarousel', 'Image Grid', 'Horizontal Scroll', 'Mad Lib Flow']),
  subTitle: _propTypes["default"].node,
  title: _propTypes["default"].node
};
List.defaultProps = {
  children: null,
  className: '',
  displayOption: 'Vertical List',
  subTitle: '',
  title: ''
};
var _default = List;
exports["default"] = _default;